/**
 * Typed doorway to the ReportsNative kit.
 *
 * The kit is plain JavaScript, so TypeScript infers each component's props
 * from its default parameter values — `items = []` becomes `never[]`, and
 * every real call site fails to compile. A `@ts-ignore` on the import does
 * not help: it silences the import, not the JSX below it.
 *
 * Rather than scatter ignores through the page, the kit crosses into TS once,
 * here. When the kit grows its own .d.ts this file is the only thing to
 * delete.
 */

/* eslint-disable @typescript-eslint/no-explicit-any */
// @ts-ignore - JavaScript module without types
import * as Kit from '../../../../components/ReportsNative';

const kit = Kit as unknown as Record<string, any>;

export const ReportCard: any = kit.ReportCard;
export const ReportSegmented: any = kit.ReportSegmented;
export const KpiStat: any = kit.KpiStat;
export const TrendAreaChart: any = kit.TrendAreaChart;
export const ArcGauge: any = kit.ArcGauge;
export const RankedBars: any = kit.RankedBars;
export const GroupedColumnChart: any = kit.GroupedColumnChart;

export const formatCurrency: (value: unknown, options?: { currency?: string; decimals?: number; compact?: boolean }) => string = kit.formatCurrency;
export const formatPercent: (value: unknown, options?: { decimals?: number }) => string = kit.formatPercent;
export const formatSigned: (value: unknown, format?: string, options?: Record<string, unknown>) => string = kit.formatSigned;
